// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => ("static/css/" + chunkId + "." + {"7884":"b788726f","9867":"3be0c991"}[chunkId] + ".css");